"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Verify = void 0;
var _mui = require("@ori-ui/mui");
var _auth = require("@ori/auth");
var _globalApiClientReact = require("@ori/global-api-client-react");
var _axios = _interopRequireDefault(require("axios"));
var _react = _interopRequireWildcard(require("react"));
var _reactHookForm = require("react-hook-form");
var _constants = require("../../constants");
var _defaultTranslations = require("../../constants/defaultTranslations");
var _notificationContext = require("../../contexts/notificationContext");
var _phoneContext = require("../../contexts/phoneContext");
var _useTranslations = require("../../hooks/useTranslations");
var _ErrorRenderer = require("../../models/ErrorRenderer");
var _FetchResult = require("../../models/FetchResult");
var _TranslationKey = require("../../models/TranslationKey");
var _utils = require("../../utils");
var _handleValidationErrors = require("../../utils/handleValidationErrors");
var _transformKeysToCamelCase = require("../../utils/transformKeysToCamelCase");
var _ActionButtonStyled = require("../ActionButton/ActionButtonStyled");
var _FormattedMessage = require("../FormattedMessage");
var _ResendLink = require("./ResendLink");
var _VerificationCodeInput = require("./VerificationCodeInput");
var _VerifyStyled = require("./VerifyStyled");
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function (e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
const Verify = props => {
  const {
    values,
    hideFormHandler,
    reset,
    shouldResendCode,
    setShouldResendCode
  } = props;
  const api = (0, _globalApiClientReact.useApiClient)();
  const {
    formatMessage
  } = (0, _useTranslations.useTranslations)();
  const {
    customerId
  } = (0, _auth.useToken)();
  const {
    setError,
    formState: {
      errors
    }
  } = (0, _reactHookForm.useFormContext)();
  const {
    refreshPhones,
    currentCustomerId
  } = (0, _phoneContext.usePhoneContext)();
  const {
    context
  } = (0, _notificationContext.useNotificationData)();
  const [isDisabledResend, setIsDisabledResend] = (0, _react.useState)(false);
  const codeInputRefs = (0, _react.useRef)([]);
  const confirmationErrorMsg = typeof errors?.ConfirmationCode?.message === 'string' ? errors?.ConfirmationCode?.message : undefined;
  const hasError = !!confirmationErrorMsg;
  const {
    telephoneNumber,
    telephoneId,
    isVerified
  } = values;
  const onNumberDelete = index => {
    const newInputIndex = index - 1;
    // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition, @typescript-eslint/strict-boolean-expressions -- is not always truthy
    if (newInputIndex >= 0 && codeInputRefs.current) {
      codeInputRefs.current[newInputIndex]?.focus();
    }
  };
  const setInputRef = (instance, index) => {
    // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition, @typescript-eslint/strict-boolean-expressions -- is not always truthy
    if (codeInputRefs.current) {
      codeInputRefs.current[index] = instance;
    }
  };
  const submitVerification = async () => {
    let codeNumbers;
    // eslint-disable-next-line @typescript-eslint/strict-boolean-expressions -- TODO we must fixed and checked correct working in separate story
    if (codeInputRefs?.current) {
      codeNumbers = codeInputRefs.current.map(input => input.value);
    }
    if (codeNumbers?.every(value => Boolean(value))) {
      const code = codeNumbers.join('');
      try {
        const response = await (0, _globalApiClientReact.updateCustomerPhone)(api, currentCustomerId ?? customerId, telephoneId?.toString() ?? '', {
          ...values,
          confirmationCode: code
        });
        const result = new _FetchResult.FetchResult(response.status);
        if (result.isSuccess()) {
          hideFormHandler?.(_constants.DisplayFeedback.Verify);
          context.notificationData.setNotificationData({
            isOpen: true,
            message: formatMessage(_TranslationKey.TranslationKey.savedSuccessfully),
            type: 'success'
          });
          refreshPhones();
          reset();
        }
      } catch (error) {
        // eslint-disable-next-line @typescript-eslint/strict-boolean-expressions -- TODO we must fixed and checked correct working in separate story
        if (_axios.default.isAxiosError(error) && error.response?.data) {
          const errorResponse = (0, _transformKeysToCamelCase.transformKeysToCamelCase)(error.response.data);
          (0, _handleValidationErrors.handleValidationErrors)(errorResponse, setError, formatMessage);
        } else {
          console.error('Unknown error updating phone:', error);
        }
      }
    }
  };
  const onNumberInput = async index => {
    const newInputIndex = index + 1;
    // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition, @typescript-eslint/strict-boolean-expressions -- is not always truthy
    if (codeInputRefs.current && newInputIndex < codeInputRefs.current.length) {
      codeInputRefs.current[newInputIndex]?.focus();
    } else {
      await submitVerification();
    }
  };
  const onPaste = async event => {
    const pastedCode = event.clipboardData.getData('text/plain');
    const codeLength = codeInputRefs.current.length;
    // eslint-disable-next-line unicorn/prefer-spread -- we need split for this
    const codeArray = pastedCode.split('').slice(0, codeLength);
    codeInputRefs.current.forEach((codeInputRef, index) => {
      if (codeArray[index] && !Number.isNaN(Number(codeArray[index]))) {
        // eslint-disable-next-line no-param-reassign, @typescript-eslint/no-unnecessary-type-assertion -- we need
        codeInputRef.value = codeArray[index];
      }
    });
    // eslint-disable-next-line @typescript-eslint/strict-boolean-expressions -- TODO we must fixed and checked correct working in separate story
    if (codeInputRefs.current.length) {
      await submitVerification();
    }
  };
  const renderVerificationCodeInput = index => /*#__PURE__*/(0, _jsxRuntime.jsx)(_VerificationCodeInput.VerificationCodeInput, {
    index: index,
    handleInput: onNumberInput,
    handleDelete: onNumberDelete,
    inputRef: setInputRef,
    handleSubmit: submitVerification,
    handlePaste: onPaste,
    hasError: hasError
  }, index);
  const renderVerificationCodeInputs = () => {
    const codeLength = 6;
    return /*#__PURE__*/(0, _jsxRuntime.jsx)(_VerifyStyled.CodeDiv, {
      children: Array.from({
        length: codeLength
      }).map((_x, index) => renderVerificationCodeInput(index))
    });
  };
  const handleResendCode = async event => {
    event?.preventDefault();
    // eslint-disable-next-line @typescript-eslint/strict-boolean-expressions -- TODO we must fixed and checked correct working in separate story
    if (telephoneId && !isDisabledResend) {
      try {
        (0, _utils.disablePhoneResendVerification)(setIsDisabledResend);
        if (isVerified) {
          await (0, _globalApiClientReact.updateCustomerPhone)(api, currentCustomerId ?? customerId, telephoneId.toString(), values);
        } else {
          await (0, _globalApiClientReact.updateCustomerPhoneVerificationRequest)(api, currentCustomerId ?? customerId, telephoneId, {
            requestStatus: _globalApiClientReact.GlobalCustomersTelephoneVerificationRequestDtoRequestStatus.Pending
          });
        }
        setShouldResendCode(false);
      } catch (error) {
        // eslint-disable-next-line @typescript-eslint/strict-boolean-expressions -- TODO we must fixed and checked correct working in separate story
        if (_axios.default.isAxiosError(error) && error.response?.data) {
          const errorResponse = (0, _transformKeysToCamelCase.transformKeysToCamelCase)(error.response.data);
          (0, _handleValidationErrors.handleValidationErrors)(errorResponse, setError, formatMessage);
        } else {
          console.error('Unknown error updating phone:', error);
        }
      }
    }
  };
  if (shouldResendCode && !isDisabledResend) {
    handleResendCode();
  }
  const renderCloseButton = () => /*#__PURE__*/(0, _jsxRuntime.jsx)(_ActionButtonStyled.ButtonCancel, {
    color: "default",
    variant: "text",
    onClick: () => hideFormHandler?.(),
    children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_FormattedMessage.FormattedMessage, {
      defaultMessage: _defaultTranslations.defaultTranslations.cancel,
      id: _TranslationKey.TranslationKey.cancel
    })
  });
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)("form", {
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_mui.Typography, {
      align: "center",
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_FormattedMessage.FormattedMessage, {
        id: _TranslationKey.TranslationKey.telephoneVerificationSent,
        defaultMessage: _defaultTranslations.defaultTranslations.telephoneVerificationSent,
        values: {
          telephoneNumber
        }
      })
    }), renderVerificationCodeInputs(), /*#__PURE__*/(0, _jsxRuntime.jsx)(_ErrorRenderer.ErrorRenderer, {
      errors: errors
    }), /*#__PURE__*/(0, _jsxRuntime.jsxs)(_mui.Typography, {
      paragraph: true,
      align: "center",
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_FormattedMessage.FormattedMessage, {
        id: _TranslationKey.TranslationKey.noCode,
        defaultMessage: _defaultTranslations.defaultTranslations.noCode
      }), ' ', /*#__PURE__*/(0, _jsxRuntime.jsx)(_ResendLink.ResendLink, {
        isResendDisabled: isDisabledResend,
        handleResendCode: handleResendCode
      })]
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_mui.Grid, {
      container: true,
      justifyContent: "center",
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_VerifyStyled.GridCancelButton, {
        children: renderCloseButton()
      })
    })]
  });
};
exports.Verify = Verify;
